<script setup>
import MerchGradientImage from '@components/global/merch/gradient-image.vue'
import Button from '@components/global/button.vue'
import CollectionSection from '@sections/merch/collection-section.vue'
import { useStoreStore } from '@stores/store'
import MerchCollectionCard from '@components/global/merch/collection-card.vue'
import MerchHeroCollectionCard from '@components/global/merch/hero-collection-card.vue'
const store = useStoreStore()
</script>

<template>
	<!-- <MerchHeroCollectionCard :collection="store.collections[0]" title="best sellers" slug="best-sellers" /> -->
	
	<CollectionSection :collection="store.collections[0]" title="best sellers" slug="best-sellers" />

	<section class="container flex flex-col gap-5 md:flex-row">
		<!-- <MerchCollectionCard v-if="store.collections.length > 0" class="w-full md:w-half" :collection="store.collections[0]" title="best sellers" slug="best-sellers" /> -->
		<!-- <MerchCollectionCard class="w-full md:w-half" :collection="store.collections[0]"" title="featured" slug="featured" /> -->
	</section>

	<!-- <CollectionSection :collection="store.collections[0]" title="just dropped" slug="just-dropped" /> -->
</template>
